import * as RadixTooltip from '@radix-ui/react-tooltip';
import { motion } from 'framer-motion';
import { forwardRef, type ReactNode } from 'react';

type TooltipWrapperProps = {
  children: ReactNode;
  tooltipContent: ReactNode;
  disableHoverable?: boolean;
  offset?: number;
};

const TooltipWrapper = forwardRef<HTMLDivElement, TooltipWrapperProps>(
  ({ children, tooltipContent, disableHoverable = false, offset = 4 }, ref) => {
    return (
      <RadixTooltip.Provider delayDuration={0} disableHoverableContent={disableHoverable}>
        <RadixTooltip.Root>
          <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
          <RadixTooltip.Portal>
            <RadixTooltip.Content side="right" sideOffset={offset} asChild>
              <motion.div
                ref={ref}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.1 }}
                // z-50 + transform-gpu lift the tooltip onto its own compositor
                // layer with explicit stacking, so it paints above any other
                // composited element on the page (e.g. a transformed sidebar in
                // the main content area).
                className="z-50 transform-gpu flex items-center gap-2 px-2 py-1 border rounded-default shadow-sm bg-primary text-secondary text-label-3 border-tertiary"
              >
                {tooltipContent}
              </motion.div>
            </RadixTooltip.Content>
          </RadixTooltip.Portal>
        </RadixTooltip.Root>
      </RadixTooltip.Provider>
    );
  },
);

TooltipWrapper.displayName = 'TooltipWrapper';

export default TooltipWrapper;
